import React from 'react'
import { clientOneData } from '../data'

import TinySlider from "tiny-slider-react";
import 'tiny-slider/dist/tiny-slider.css';

export default function ClientTwo() {
    const settings = {
        container: '.tiny-single-item',
        items: 1,
        controls: false,
        mouseDrag: true,
        loop: true,
        rewind: true,
        autoplay: true,
        autoplayButtonOutput: false,
        autoplayTimeout: 3000,
        navPosition: "bottom",
        speed: 400,
        gutter: 16,
      };

  return (
        <div className="tiny-single-item">  
            <TinySlider settings={settings}>
                {clientOneData.map((item,index)=>{
                    return(
                        <div className="tiny-slide" key={index}>
                            <div className="single-review text-center">
                                <ul className="list-unstyled h5 text-warning">
                                    <li className="list-inline-item"><i className="mdi mdi-star fs-6"></i></li>
                                    <li className="list-inline-item"><i className="mdi mdi-star fs-6"></i></li>
                                    <li className="list-inline-item"><i className="mdi mdi-star fs-6"></i></li>
                                    <li className="list-inline-item"><i className="mdi mdi-star fs-6"></i></li>
                                    <li className="list-inline-item"><i className="mdi mdi-star fs-6"></i></li>
                                </ul>
                                <p className="text-white h5 review fst-italic fw-normal">{item.desc}</p>
                                <div className="reviewer mt-3">
                                    <img src={item.image} className="img-fluid avatar avatar-small rounded-pill mx-auto shadow" alt=""/>
                                    <h6 className="mt-2 mb-0 text-light title-dark">{item.name}</h6>
                                    <p className="text-danger mb-0">{item.title}</p>
                                </div>
                            </div>
                        </div>
                    )
                })} 
            </TinySlider>
        </div>
  )
}
